import { FilterOps, GQL_ID } from '@@types'
import { generatePath } from 'react-router'

import { useFetchAllProducts } from '@entities/Product'
import { useSingleProductGroup } from '@entities/ProductGroup/api/singleProductGroup.gql'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'

import { IMAGE_SIZES, URL_PAGE_PRODUCT_GROUP } from '@shared/contants'



type ProductsGroupCarouselProps = {
  id: string
}

export default function ProductsGroupCarousel ({
  id
}: ProductsGroupCarouselProps) {
  const { shopId } = useAddressStore()
  
  const { group } = useSingleProductGroup({
    id,
    shop_id: shopId as GQL_ID,
    style: IMAGE_SIZES.LARGE,
  })

  const { products, loading } = useFetchAllProducts({
    filter: {
      fields: [ 'productGroupIds' ],
      op: FilterOps.CONTAINS,
      value: [ id ]
    },
    pager: {
      page: 1,
      limit: 12
    },
    shop_id: shopId,
    style: IMAGE_SIZES.LARGE,
  })

  return (
    <>
      <ProductCarousel
        title={group?.label ?? ''}
        products={products}
        link={generatePath(URL_PAGE_PRODUCT_GROUP, { productGroupId: id })}
        loading={loading}
      />
    </>
  )
};